.heading {
  margin-bottom: 1em;
}

.pagination {
  padding: 1em 0;
}
